import { useState } from "react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { ActionIcon, Tooltip } from "@mantine/core";
import { IconTrash } from "@tabler/icons-react";
import { deleteFailedJob } from "../../../../../api/JobsAPI";

const DeleteJob = ({ id, onFinish }) => {
  const lang = useLanguage((s) => s.language);
  const [loading, setLoading] = useState(false);
  const handleDelete = () => {
    setLoading(true);
    deleteFailedJob(id)
      .then((response) => {
        onFinish();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Tooltip label={lang.contact_lists.delete_keep.dialog.submit_button}>
      <ActionIcon
        variant="subtle"
        color="red"
        ml={"auto"}
        loading={loading}
        onClick={handleDelete}
        size="md"
      >
        <IconTrash size={18} />
      </ActionIcon>
    </Tooltip>
  );
};

export default DeleteJob;
